/** Reine Helfer der Eingangspruefung (Labels, Standard-Entscheidungen, Request-Body). Kein React-/Router-Import (isoliert testbar). */

export const GRUND_LABEL = {
  KLIENT_FEHLT: 'Klient nicht zugeordnet',
  KLIENT_NICHT_IM_TEXT_BELEGT: 'Klient steht nicht im Dokumenttext – Zuordnung bitte prüfen',
  MEHRERE_KONKURRIERENDE_ZIELAUFGABEN: 'Mehrere mögliche Zielaufgaben',
  MEHRFACHER_VORSCHLAG_FUER_DIESELBE_AUFGABE: 'Mehrere Vorschläge für dieselbe Aufgabe',
  HANDLUNGSBEDARF_WIDERSPRUCH: 'Handlungsbedarf unklar',
  FRIST_IN_VERGANGENHEIT: 'Frist liegt in der Vergangenheit',
  UNKNOWN_DOCUMENT_ATTACHMENT: 'Unbekannter Anhang',
  PSEUDONYMISIERUNG_ZURUECKGEHALTEN: 'Pseudonymisierung unvollständig',
  ZIEL_FEHLT: 'Zielaufgabe existiert nicht mehr',
  ZIEL_FREMDER_KLIENT: 'Zielaufgabe gehört einem anderen Klienten',
  ZIEL_GESCHLOSSEN: 'Zielaufgabe ist bereits erledigt',
  ZIEL_SAMMELAUFGABE: 'Ziel ist die Büro-Sammelaufgabe',
  ZIEL_THEMA_UNSICHER: 'Zielaufgabe passt thematisch nicht sicher',
  AUFGABE_NICHT_IM_TEXT_VERANKERT: 'Vorgeschlagene Aufgabe steht so nicht im Dokumenttext',
  DUPLIKAT_VERDACHT: 'Ähnliche offene Aufgabe existiert bereits',
  FRIST_NICHT_IM_TEXT_BELEGT: 'Frist steht nicht im Dokumenttext',
  ZUORDNUNG_KONFLIKT: 'Zuordnung widersprüchlich (Betreuungsbeschluss) – nur Konfliktprüfung, keine Übernahme von Vorschlägen',
  ZUORDNUNG_KONFLIKT_GESPERRT: 'Gehört nicht zu diesem Fall – nur verwerfen',
  PRUEFHINWEIS_OFFEN: 'Prüfhinweis aus der Nachkorrektur – bitte Original prüfen und bestätigen',
  OHNE_SCAN_EINTRAG_MANUELL: 'Ohne offenen Scan-Eintrag (getrennter Teil oder Altfall) – wird nie automatisch abgeschlossen',
  VOLLTEXT_PRUEFUNG_OFFEN: 'KI-Analyse nicht vollständig oder widersprüchlich – bitte Original prüfen',
  NACHANALYSE_PRUEFUNG_OFFEN: 'Ergebnisse der Nachanalyse prüfen (Fristen mit Beleg, Handlungspflichten, Abweichungen)',
};

/** Datumsarten der Nachanalyse (services/nachanalyse_fachpruefung.py) */
export const ART_LABEL = {
  behoerdliche_frist: 'Ausdrückliche Frist', befristung: 'Befristung (Zeitraum endet)', wiedervorlage: 'Interne Wiedervorlage', leistungsbeginn: 'Leistungsbeginn',
  rechnungsdatum: 'Rechnungs-/Abrechnungsdatum', gesetz_satzung: 'Datum aus Gesetz/Satzung/Merkblatt', rechtsbehelf: 'Rechtsbehelfsfrist (nur bei Widerspruchsabsicht)',
  sonstiges: 'Sonstige Datumsangabe', fristsignal: 'Mögliche Frist im Original (von der KI nicht bewertet)',
};

export const KEINE_FRIST_GRUND = {
  normtext: 'steht in Gesetz-/Satzungstext', allgemeine_vertrags_oder_abrechnungsregel: 'allgemeine Vertrags- oder Abrechnungsregel',
  beleg_nicht_im_original: 'Beleg im Original nicht gefunden', keine_konkrete_handlung: 'keine konkrete Handlung', datum_nicht_im_beleg: 'Datum steht nicht im Beleg',
  vor_dem_schreiben: 'liegt vor dem Schreiben', keine_frist_leistungsbeginn: 'Leistungsbeginn', keine_frist_rechnungsdatum: 'Rechnungs-/Abrechnungsdatum',
  keine_frist_gesetz_satzung: 'Gesetz/Satzung/Merkblatt', keine_frist_rechtsbehelf: 'Rechtsbehelfsfrist – nur bei Widerspruchsabsicht', keine_frist_wiedervorlage: 'interne Wiedervorlage',
  keine_frist_sonstiges: 'keine Frist', befristung_ohne_leistungs_oder_zeitraumbezug: 'kein Ablauf eines Leistungs- oder Unterbringungszeitraums',
  von_ki_nicht_bewertet: 'bitte im Original prüfen',
};

export const LAGE_LABEL = { vergangen: 'bereits verstrichen', bald: 'in den nächsten 30 Tagen', kuenftig: 'künftig' };

/** Datei-Reviews (Datei-Ebene) mit ihrem vollständigen Text -- werden NICHT als Auswahl angezeigt, aber immer gelesen. */
export function dateiReviews(dok) {
  return (dok.vorschlaege || []).filter((v) => v.action === 'REVIEW_PROCESSING' && (v.begruendung || '').trim());
}

/** Entscheidung erst nach ausdruecklicher Bestaetigung, wenn Pruefinformationen vorliegen (Server prueft dasselbe). */
export function entscheidbar(dok, bestaetigt) {
  return !dok.pruefinfo_bestaetigung_noetig || !!bestaetigt;
}

/** Text der Bestaetigung: bei aelterer Nachanalyse ohne Details ausdruecklich auf das Original verweisen. */
export function bestaetigungsText(dok) {
  const na = dok.nachanalyse;
  if (na && na.details_fehlen) return 'Die Prüfinformationen dieser älteren Nachanalyse sind unvollständig. Ich habe das Original vollständig gelesen.';
  return 'Ich habe die Prüfinformationen (Fristen mit Beleg, Handlungspflichten, Abweichungen, Personen) und das Original gelesen.';
}

export const EFFEKT_LABEL = {
  task: 'Aufgabe/Entscheidung zur Aufgabe', deadline: 'Frist', case_assignment: 'Klientenzuordnung', canonical_file_location: 'Ablageordner',
  structured_case_data: 'Strukturierte Falldaten', document_metadata: 'Dokument-Metadaten', ki_analyse: 'KI-Analyse (fehlt – Original lesen)',
  full_text_analysis: 'Prüfung der Volltextanalyse', page_segmentation: 'Prüfung der Seitentrennung',
};

const PRIO_RANG = { dringend: 0, hoch: 1, mittel: 2, niedrig: 3 };

/** Hoechste Prioritaet eines Dokuments (Pruefhinweis + Vorschlaege) oder null. */
export function dokPrioritaet(dok) {
  const alle = [dok.pruefhinweis && dok.pruefhinweis.prioritaet, ...(dok.vorschlaege || []).map((v) => v.prioritaet)]
    .map((p) => String(p || '').toLowerCase()).filter((p) => p in PRIO_RANG);
  if (!alle.length) return null;
  return alle.sort((a, b) => PRIO_RANG[a] - PRIO_RANG[b])[0];
}

/** Kurzbeschreibung der Herkunft eines getrennten Teils. */
export function teilText(teil) {
  if (!teil) return '';
  const seiten = teil.von ? (teil.von === teil.bis ? `Seite ${teil.von}` : `Seiten ${teil.von}–${teil.bis}`) : '';
  return [`Getrennter Teil ${teil.index || '?'} von ${teil.anzahl || '?'}`, seiten && `${seiten} der Sammeldatei`].filter(Boolean).join(', ');
}

/** Tatsaechlicher Grund eines Widerspruchs (Codes aus analyse_abdeckung / nachanalyse_fachpruefung). */
export const WIDERSPRUCH_TEXT = {
  abweichende_fristen_in_abschnitten: 'spätere Abschnitte nennen andere Fristen als die Hauptanalyse',
  handlungsbedarf_nur_in_abschnitten: 'Handlungsbedarf steht nur in späteren Abschnitten',
  weitere_personen_in_abschnitten: 'in späteren Abschnitten werden weitere Personen genannt (Rolle bitte prüfen)',
  abweichende_fristen: 'gleiche Handlung mit verschiedenen Daten',
  person_anderer_klient: 'eine genannte Person ist selbst Klient – Zuordnung prüfen',
  person_unbekannt_betroffen: 'eine unbekannte Person ist betroffen – Zuordnung prüfen',
};

/** Hinweistext zur Volltextanalyse. */
export function volltextText(v) {
  if (!v) return '';
  if (!v.vollstaendig) return 'Die KI hat nicht alle Abschnitte des Dokuments analysiert.';
  if (v.widersprueche && v.widersprueche.length) return `Widersprüchliche Angaben: ${v.widersprueche.map((w) => WIDERSPRUCH_TEXT[w] || w).join('; ')}.`;
  if (v.befunde_ausserhalb) return 'Fristen oder Handlungspflichten stehen außerhalb des zuerst analysierten Teils.';
  return 'Die Volltextanalyse verlangt eine Prüfung.';
}

export const ACTION_LABEL = { CREATE: 'Neue Aufgabe', UPDATE: 'Bestehende Aufgabe ergänzen', DEADLINE_CREATE: 'Neue Frist', DEADLINE_UPDATE: 'Frist ändern' };

export function grundText(g) {
  if (GRUND_LABEL[g]) return GRUND_LABEL[g];
  if (g && g.startsWith('WEITERE_EFFEKTE_FEHLEN:')) return `Es fehlt noch: ${g.split(':')[1].split(',').map((e) => EFFEKT_LABEL[e] || e).join(', ')}`;
  return g;
}

/** Vorschlaege (ohne Datei-Ebene) eines Dokuments. */
export function hauptVorschlaege(dok) {
  return (dok.vorschlaege || []).filter((v) => v.action !== 'REVIEW_PROCESSING');
}

/** Hinweise ausser der (korrigierbaren) unbelegten Frist verlangen eine bewusste Entscheidung. */
const echteHinweise = (v) => (v.hinweise || []).filter((h) => h !== 'FRIST_NICHT_IM_TEXT_BELEGT');

/** Standard: unauffaellig = uebernehmen; unbelegte Frist = Aufgabe ohne Frist uebernehmen / Frist-Eintrag verwerfen (Fachguard); sonstige Hinweise = verwerfen (Benutzer entscheidet). */
export function standardEntscheidungen(dok) {
  const e = {};
  hauptVorschlaege(dok).forEach((v) => {
    if (echteHinweise(v).length) e[v.review_id] = 'REJECTED';
    else if (v.korrektur === 'FRIST_ENTFERNEN') e[v.review_id] = v.action === 'CREATE' ? 'APPROVED_OHNE_FRIST' : 'REJECTED';
    else e[v.review_id] = 'APPROVED';
  });
  return e;
}

/** Auswahlmoeglichkeiten je Vorschlag. */
export const gesperrt = (v) => (v.hinweise || []).includes('ZUORDNUNG_KONFLIKT_GESPERRT');

/** Frist-Anzeige: eine nicht im Dokument belegte Frist wird nie als berechnetes Datum gezeigt (Praxisfall 24.10.2026, Beschwerdefrist). */
export function fristText(v) {
  if (!v.faellig_am) return null;
  return (v.hinweise || []).includes('FRIST_NICHT_IM_TEXT_BELEGT') ? 'Frist nicht belegt – nicht berechnet' : `Frist ${v.faellig_am}`;
}

export function optionenFuer(v) {
  if (gesperrt(v)) return [['REJECTED', 'Verwerfen']];          // widerspruechliche Zuordnung: Server sperrt jede Uebernahme ebenfalls
  const o = [['APPROVED', 'Übernehmen']];
  if (v.action === 'CREATE' && v.korrektur === 'FRIST_ENTFERNEN') o.push(['APPROVED_OHNE_FRIST', 'Ohne Frist übernehmen']);
  o.push(['REJECTED', 'Verwerfen']);
  return o;
}

/** `neueAufgabe` wird nur gesendet, wenn ein ausreichend langer Titel eingegeben wurde. */
export function baueBody({ entscheidungen, klientId, keineHandlung, neueAufgabe, pruefinfoBestaetigt }) {
  const n = neueAufgabe && (neueAufgabe.titel || '').trim().length >= 5 ? { ...neueAufgabe, titel: neueAufgabe.titel.trim(), faellig_am: neueAufgabe.faellig_am || null } : null;
  return { entscheidungen: keineHandlung ? {} : (entscheidungen || {}), klient_id: klientId || null, keine_handlung: !!keineHandlung, neue_aufgabe: keineHandlung ? null : n,
    pruefinfo_bestaetigt: !!pruefinfoBestaetigt };
}

export const istRetarget = (w) => typeof w === 'string' && w.startsWith('RETARGET:');
export const retargetId = (w) => (istRetarget(w) ? w.slice(9) : null);

/** Bei geaendertem Klienten duerfen bisherige Vorschlaege nicht uebernommen werden -> alles auf "verwerfen". */
export function bereinigeBeiKlientenwechsel(dok, entscheidungen, klientId) {
  if (!klientId || klientId === (dok.klient && dok.klient.id)) return entscheidungen;
  const e = {};
  Object.keys(entscheidungen).forEach((k) => { e[k] = 'REJECTED'; });
  return e;
}

export function filtere(dokumente, filter) {
  if (filter === 'human') return dokumente.filter((d) => d.klasse === 'HUMAN');
  if (filter === 'auto') return dokumente.filter((d) => d.klasse === 'AUTO');
  return dokumente.filter((d) => d.klasse !== 'BEREIT');       // "wartet auf Archivierung" ist keine offene Arbeit
}
